import { observer } from "mobx-react-lite";
import { FunctionComponent, useContext } from "react";

import {
  Heading,
  IButtonProps,
  IDialogContentProps,
  Text
} from "@bps/fluent-ui";
import { SubmissionFormDialog } from "@ui-components/form/submission-form-dialog/SubmissionFormDialog.tsx";

import { InvoiceFormContext } from "../../context/InvoiceFormContext.tsx";

export const InvoiceExistsModal: FunctionComponent<{
  name: string | undefined;
}> = observer(props => {
  const {
    onClose,
    isInvoiceExistsModalVisible: isInvoiceExistModalVisible,
    setIsInvoiceExistsModalVisible: setIsInvoiceExistModalVisible
  } = useContext(InvoiceFormContext);

  if (!isInvoiceExistModalVisible) {
    return null;
  }

  const onDismiss = () => {
    setIsInvoiceExistModalVisible(false);
    onClose();
  };

  const dialogContentProps: IDialogContentProps = {
    title: (
      <Heading variant="modal-heading">Appointment already invoiced</Heading>
    )
  };

  const submitButtonProps: IButtonProps = {
    text: "Create",
    iconProps: { iconName: undefined },
    disabled: false
  };

  return (
    <SubmissionFormDialog
      dialogName="Appointment already invoiced"
      onSubmit={() => setIsInvoiceExistModalVisible(false)}
      dialogProps={{
        showTitleSeparator: true,
        onDismiss,
        minWidth: 600,
        dialogContentProps,
        styles: {
          root: {
            ".ms-Dialog-action": { width: "100%" }
          }
        }
      }}
      buttonsProps={{
        submitButtonProps
      }}
    >
      {() => (
        <Text>
          Are you sure you want to generate another invoice for {props.name}?
        </Text>
      )}
    </SubmissionFormDialog>
  );
});
